import { render } from "./ChiTietBaiViet.vue?vue&type=template&id=1e807432&scoped=true"
import script from "./ChiTietBaiViet.vue?vue&type=script&lang=js"
export * from "./ChiTietBaiViet.vue?vue&type=script&lang=js"

import "./ChiTietBaiViet.vue?vue&type=style&index=0&id=1e807432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e807432"]])

export default __exports__